import { lazy } from "react";
import type { MotionVersionsProps } from "./MotionVersions";
const MotionVersions = lazy(() => import("./MotionVersions").then(module => ({ default: module.MotionVersions })));
import { setStudioView } from "../workspace/studio-views";

export function mountMotionVersions(
  slot: HTMLElement,
  props: MotionVersionsProps,
) {
  setStudioView("motion-versions", `motion-versions:${props.project.id}:${props.sceneId}`, <MotionVersions key={`${props.project.id}:${props.sceneId}`} {...props} />);
}
